var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"label":_vm.$t('category'),"rules":_vm.categoryRules,"items":_vm.categoriesData,"item-text":"name","item-value":"id"},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}})
}
var staticRenderFns = []

export { render, staticRenderFns }